import React from 'react';

export default function ConversationsMobileToggle({
  mobileView,
  hasSelectedConversation,
  onToggle,
}: {
  mobileView: 'list' | 'chat';
  hasSelectedConversation: boolean;
  onToggle: (view: 'list' | 'chat') => void;
}) {
  return (
    <div className="border-b border-gray-200 bg-white px-3 py-2">
      <div className="mx-auto inline-flex gap-1 rounded-full bg-gray-200 p-1 shadow-sm">
        <button
          type="button"
          onClick={() => onToggle('list')}
          aria-pressed={mobileView === 'list'}
          className={`px-4 py-1 text-xs font-semibold rounded-full transition ${
            mobileView === 'list' ? 'bg-white text-teal-600 shadow' : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          Lista
        </button>
        <button
          type="button"
          onClick={() => onToggle('chat')}
          disabled={!hasSelectedConversation}
          aria-pressed={mobileView === 'chat'}
          className={`px-4 py-1 text-xs font-semibold rounded-full transition ${
            mobileView === 'chat' ? 'bg-white text-teal-600 shadow' : 'text-gray-600 hover:text-gray-800'
          } ${!hasSelectedConversation ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          Conversa
        </button>
      </div>
    </div>
  );
}
